import * as AnalyticAppColor from 'common/constants/analytic-app-color';
import {
  AnalyticAppOutcomeEnum,
  MeterTypeEnum,
  StatisticsEnum,
  TimeResolutionEnum,
} from 'common/proxies/enum-proxy';
import {t} from 'common/utils/translation-util';
import * as TrendsComparison from 'trends/constants/trends-comparison';

// TODO draw these rules from the server
// This has gotten way too big

const ChartSeriesType = {
  UNDEFINED: {
    displayName: t('Undefined'),
    id: 0,
    slug: 'undefined',
  },
  AREA: {
    displayName: t('Area'),
    id: 1,
    slug: 'area',
  },
  COLUMN: {
    displayName: t('Column'),
    id: 2,
    slug: 'column',
  },
  CLUSTERED_COLUMN: {
    displayName: t('Clustered Column'),
    id: 3,
    slug: 'clusteredColumn',
  },
  HEAT_MAP: {
    displayName: t('Heat Map'),
    id: 4,
    slug: 'heatmap',
  },
  HISTOGRAM: {
    displayName: t('Histogram'),
    id: 5,
    slug: 'histogram',
  },
  LINE: {
    displayName: t('Line'),
    id: 6,
    slug: 'line',
  },
};

function electricalChartDisplayRules(type) {
  const isElectricity = type.slug === MeterTypeEnum.ELECTRICITY.slug;
  return {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.BASELOAD,
      StatisticsEnum.PEAK,
    ],
    slug: type.slug,
    showBaseload: true,
    showPeak: true,
    includePeakInStatistics: isElectricity,
    productionMeterLayers: isElectricity,
    type,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.ORANGE,
    iconClass: type.icon,
  };
}

function getSensorRules(type) {
  return {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
    ],
    statistics: [StatisticsEnum.TOTAL, StatisticsEnum.PEAK],
    slug: type.slug,
    showBaseload: false,
    showPeak: false,
    type,
    outcome: AnalyticAppOutcomeEnum.OTHER,
    color: AnalyticAppColor.GRAY,
    iconClass: type.icon,
  };
}

function makeDefaultRules(type) {
  // A default set of rules that does not have any extra base/peak statistics,
  // and has a gray color
  return {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
    ],
    statistics: [StatisticsEnum.TOTAL],
    slug: type.slug,
    showBaseload: false,
    showPeak: false,
    type,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.GRAY,
    iconClass: type.icon,
  };
}

function makeDefaultsEnum() {
  // Creates default values for all the types which were not yet covered
  // There is a DEFAULT type that provides a fallback, should this types array
  // Fail to be updated when a new meter type is added
  const defaultTypes = [
    'AIR_FLOW',
    'CO2_HVAC',
    'DEPTH',
    'DIESEL',
    'DEFAULT',
    'GRID_RENEWABLE_ENERGY',
    'HOT_WATER',
    'HUMIDITY_INDOORS',
    'IRRIGATION',
    'OTHER',
    'PERCENT_OCCUPIED',
    'PRESSURE',
    'PROPANE',
    'STATUS',
    'STEAM',
    'TEMPERATURE_HVAC',
    'TEMPERATURE_INDOORS',
    'UNDEFINED',
    'WATER_FLOW',
  ];
  const defaults = {};
  for (const name of defaultTypes) {
    defaults[name] = makeDefaultRules(MeterTypeEnum[name]);
  }
  return defaults;
}

export default Object.assign(makeDefaultsEnum(), {
  getDefault: (slug) => {
    const type = slug && MeterTypeEnum[slug.toUpperCase()];
    if (type) {
      return makeDefaultRules(type);
    }
  },
  BAROMETRIC_PRESSURE: getSensorRules(MeterTypeEnum.BAROMETRIC_PRESSURE),
  CO_GEN: electricalChartDisplayRules(MeterTypeEnum.CO_GEN),
  COMPOST: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
    ],
    statistics: [StatisticsEnum.TOTAL],
    slug: MeterTypeEnum.COMPOST.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.COMPOST,
    outcome: AnalyticAppOutcomeEnum.OTHER,
    color: AnalyticAppColor.GREEN,
    iconClass: MeterTypeEnum.COMPOST.icon,
  },
  COOLING: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.PEAK,
      StatisticsEnum.COOLING_DEGREE_DAYS,
    ],
    slug: MeterTypeEnum.COOLING.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.COOLING,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.BLUE_GRAY,
    iconClass: MeterTypeEnum.COOLING.icon,
  },
  ELECTRICITY: electricalChartDisplayRules(MeterTypeEnum.ELECTRICITY),
  ENERGY: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.BASELOAD,
      StatisticsEnum.PEAK,
      StatisticsEnum.HEATING_DEGREE_DAYS,
    ],
    slug: MeterTypeEnum.ENERGY.slug,
    showBaseload: true,
    showPeak: true,
    type: MeterTypeEnum.ENERGY,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.ORANGE,
    iconClass: MeterTypeEnum.ENERGY.icon,
  },
  FUEL_OIL_1: {
    displayName: t('Fuel Oil'),
    slug: MeterTypeEnum.DISTILLATE_FUEL_OIL_1.slug,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
  },
  NATURAL_GAS: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.PEAK,
      StatisticsEnum.HEATING_DEGREE_DAYS,
    ],
    slug: MeterTypeEnum.NATURAL_GAS.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.NATURAL_GAS,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.PURPLE,
    iconClass: MeterTypeEnum.NATURAL_GAS.icon,
  },
  GEOTHERMAL: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.PEAK,
      StatisticsEnum.HEATING_DEGREE_DAYS,
    ],
    slug: MeterTypeEnum.GEOTHERMAL.slug,
    showBaseload: false,
    showPeak: false,
    includePeakInStatistics: true,
    type: MeterTypeEnum.GEOTHERMAL,
    outcome: AnalyticAppOutcomeEnum.PRODUCTION,
    color: AnalyticAppColor.RED,
    iconClass: MeterTypeEnum.GEOTHERMAL.icon,
  },
  HEATING: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.PEAK,
      StatisticsEnum.HEATING_DEGREE_DAYS,
    ],
    slug: MeterTypeEnum.HEATING.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.HEATING,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.RED,
    iconClass: MeterTypeEnum.HEATING.icon,
  },
  HUMIDITY: getSensorRules(MeterTypeEnum.HUMIDITY),
  IRRADIANCE: getSensorRules(MeterTypeEnum.IRRADIANCE_WEATHER),
  OCCUPANTS: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
    ],
    statistics: [StatisticsEnum.TOTAL],
    slug: MeterTypeEnum.OCCUPANTS.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.OCCUPANTS,
    outcome: AnalyticAppOutcomeEnum.OTHER,
    color: AnalyticAppColor.PAPAYA,
    iconClass: MeterTypeEnum.OCCUPANTS.icon,
  },
  PRECIPITATION: getSensorRules(MeterTypeEnum.PRECIPITATION),
  PV: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
    ],
    statistics: [StatisticsEnum.TOTAL, StatisticsEnum.PEAK],
    slug: MeterTypeEnum.PV.slug,
    showBaseload: false,
    showPeak: false,
    includePeakInStatistics: true,
    consumptionMeterLayers: true,
    type: MeterTypeEnum.PV,
    outcome: AnalyticAppOutcomeEnum.PRODUCTION,
    color: AnalyticAppColor.GREEN,
    iconClass: MeterTypeEnum.PV.icon,
  },
  RAINWATER: getSensorRules(MeterTypeEnum.RAINWATER),
  RECYCLING: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
    ],
    statistics: [StatisticsEnum.TOTAL],
    slug: MeterTypeEnum.RECYCLING.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.RECYCLING,
    outcome: AnalyticAppOutcomeEnum.OTHER,
    color: AnalyticAppColor.BLUE,
    iconClass: MeterTypeEnum.RECYCLING.icon,
  },
  SOLAR_THERMAL: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
    ],
    statistics: [StatisticsEnum.TOTAL, StatisticsEnum.PEAK],
    slug: MeterTypeEnum.SOLAR_THERMAL.slug,
    showBaseload: false,
    showPeak: false,
    includePeakInStatistics: true,
    type: MeterTypeEnum.SOLAR_THERMAL,
    outcome: AnalyticAppOutcomeEnum.PRODUCTION,
    color: AnalyticAppColor.PAPAYA,
    iconClass: MeterTypeEnum.SOLAR_THERMAL.icon,
  },
  TEMPERATURE: getSensorRules(MeterTypeEnum.TEMPERATURE),
  TOTAL_ENERGY: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.HDD,
      TrendsComparison.CDD,
    ],
    statistics: [
      StatisticsEnum.TOTAL,
      StatisticsEnum.BASELOAD,
      StatisticsEnum.PEAK,
      StatisticsEnum.HEATING_DEGREE_DAYS,
    ],
    slug: MeterTypeEnum.TOTAL_ENERGY.slug,
    showBaseload: true,
    showPeak: true,
    type: MeterTypeEnum.TOTAL_ENERGY,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.ORANGE,
    iconClass: MeterTypeEnum.TOTAL_ENERGY.iconClass,
  },
  WASTE: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
    ],
    statistics: [StatisticsEnum.TOTAL],
    slug: MeterTypeEnum.WASTE.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.WASTE,
    outcome: AnalyticAppOutcomeEnum.OTHER,
    color: AnalyticAppColor.GRAY,
    iconClass: MeterTypeEnum.WASTE.icon,
  },
  WATER: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      today: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      week: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last24hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last48hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      last7days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.COLUMN,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.TEMPERATURE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
      TrendsComparison.FORECAST,
    ],
    statistics: [StatisticsEnum.TOTAL, StatisticsEnum.PEAK],
    slug: MeterTypeEnum.WATER.slug,
    showBaseload: false,
    showPeak: false,
    type: MeterTypeEnum.WATER,
    outcome: AnalyticAppOutcomeEnum.CONSUMPTION,
    color: AnalyticAppColor.BLUE,
    iconClass: MeterTypeEnum.WATER.icon,
  },
  WEATHER: getSensorRules(MeterTypeEnum.WEATHER_OTHER),
  WIND: {
    periods: {
      yesterday: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      today: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      week: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      month: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      year: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lastweek: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lastmonth: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lastyear: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lasthour: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last2hours: {
        resolution: TimeResolutionEnum.LIVE,
        series: ChartSeriesType.AREA,
      },
      last24hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last48hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      last7days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      last4weeks: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last30days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      last6months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      last12months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      lessThan48Hours: {
        resolution: TimeResolutionEnum.QUARTER_HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan7Days: {
        resolution: TimeResolutionEnum.HOUR,
        series: ChartSeriesType.AREA,
      },
      lessThan30Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan90Days: {
        resolution: TimeResolutionEnum.DAY,
        series: ChartSeriesType.COLUMN,
      },
      lessThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
      moreThan12Months: {
        resolution: TimeResolutionEnum.MONTH,
        series: ChartSeriesType.COLUMN,
      },
    },
    layers: [
      TrendsComparison.NONE,
      TrendsComparison.PREVIOUS,
      TrendsComparison.LAST,
    ],
    statistics: [StatisticsEnum.TOTAL, StatisticsEnum.PEAK],
    slug: MeterTypeEnum.WIND.slug,
    showBaseload: false,
    showPeak: false,
    includePeakInStatistics: true,
    consumptionMeterLayers: true,
    type: MeterTypeEnum.WIND,
    outcome: AnalyticAppOutcomeEnum.PRODUCTION,
    color: AnalyticAppColor.GRAY,
    iconClass: MeterTypeEnum.WIND.icon,
  },
  WIND_DIRECTION: getSensorRules(MeterTypeEnum.WIND_DIRECTION),
  WIND_SPEED: getSensorRules(MeterTypeEnum.WIND_SPEED),
});
